export default __webpack_public_path__ + "static/media/add-location.bfb7c3e0.svg";